<script setup>
import { computed } from 'vue'
import { useClipboard } from '@vueuse/core'

const props = defineProps({
  message: {
    type: String,
    required: true
  }
})

const source = computed(() => props.message)
const { copy, copied } = useClipboard({
  source
})

const tooltip = computed(() => copied.value ? 'Copied' : 'Click to copy')

</script>

<template>
  <button
    class="btn btn-light btn-icon btn-xs hint--rounded hint--top-right"
    :aria-label="tooltip"
    @click="copy()"
  >
    <i
      v-if="copied"
      class="fas fa-clipboard-check"
    />
    <i
      v-else
      class="fas fa-clipboard"
    />
  </button>
</template>
